(() => {
  'use strict';

  const CATALOG_UI=window.myromyQ4?.catalogUi||{};
  const decodeEntities=(value)=>{
    const textarea=document.createElement('textarea');
    textarea.innerHTML=String(value||'');
    return textarea.value;
  };
  const ui=(key)=>decodeEntities(CATALOG_UI[key]||'');

  const COLLECTIONS = {
    'keramik-kochen-backen-shop': 'boutique',
    'keramik-braeter-brotbackform-schmortopf': 'braeter',
    'brottopf-keramik-brotaufbewahrung': 'brottopf',
    'brick-backsteine': 'brick',
    'auflaufform-keramik-plancha-classic': 'plancha-classic',
    'grillplatte-keramik-plancha-bbq': 'plancha-bbq'
  };

  const STYLES = `
    .myromy-card-teasers,.myromy-teaser-list{display:none!important}
    product-list[data-myromy-curated="true"]{display:block!important;width:100%!important;min-width:0!important}
    .myromy-curated-family{grid-column:1/-1!important;display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;min-width:0!important;gap:22px!important;position:relative!important}
    .myromy-curated-family+.myromy-curated-family{margin-top:20px!important;padding-top:28px!important;border-top:1px solid rgb(var(--text-color)/.12)!important}
    .myromy-curated-family__heading{width:100%!important;margin:0 auto!important;text-align:center!important;font-size:clamp(18px,2vw,24px);line-height:1.15;letter-spacing:-.01em}
    .myromy-curated-row{display:flex!important;flex-direction:column!important;align-items:stretch!important;width:100%!important;min-width:0!important;gap:10px!important;position:relative!important;margin:0!important}
    .myromy-curated-row+.myromy-curated-row{margin-top:14px!important}
    .myromy-curated-row__label{width:100%!important;margin:0 auto!important;text-align:center!important;position:static!important;font-size:12px;font-weight:650;letter-spacing:.06em;text-transform:uppercase;opacity:.62}
    .myromy-curated-row__grid{display:grid!important;width:100%!important;margin-inline:auto!important;gap:var(--grid-gutter)!important;align-items:start!important;justify-content:center!important;min-width:0!important;position:relative!important;grid-auto-flow:row!important}
    .myromy-curated-row__grid[data-count="1"]{grid-template-columns:minmax(0,360px)!important;max-width:360px!important}
    .myromy-curated-row__grid[data-count="2"]{grid-template-columns:repeat(2,minmax(0,340px))!important;max-width:760px!important}
    .myromy-curated-row__grid[data-count="3"]{grid-template-columns:repeat(3,minmax(0,1fr))!important;max-width:1040px!important}
    .myromy-curated-row__grid[data-count="4"]{grid-template-columns:repeat(4,minmax(0,1fr))!important;max-width:1240px!important}
    .myromy-curated-row__grid product-card{min-width:0!important;width:100%!important;text-align:center!important;grid-column:auto!important;grid-row:auto!important}
    .myromy-curated-row__grid product-card .product-card__info{width:100%!important;text-align:center!important;align-items:center!important;justify-items:center!important}
    .myromy-curated-row__grid product-card .product-card__title,.myromy-curated-row__grid product-card price-list{display:block!important;width:100%!important;text-align:center!important}
    .myromy-curated-row__grid product-card .product-card__quick-buy{margin-inline:auto!important}
    .mcf__head{margin-inline:auto!important;text-align:center!important}
    .mcf__choice-nav{justify-content:center!important}
    .mcf__group-head{justify-content:center!important;text-align:center!important}
    .mcf__group-copy{margin-left:auto!important;margin-right:auto!important}
    #myromy-collection-intro .myromy-family-guidance__copy,
    #myromy-collection-intro .myromy-family-guidance__not-for,
    #myromy-collection-filter-guide .myromy-family-choice__heading,
    #myromy-collection-edition-guide .myromy-family-editions__heading{text-align:center!important}
    .mse-life .mse-life__head{margin-left:auto!important;margin-right:auto!important;text-align:center!important}
    .mse-life .mse-life__head h2,.mse-life .mse-life__lead,.mse-life .mse-life__copy{margin-left:auto!important;margin-right:auto!important}
    .mse-life .mse-life__media figure{cursor:default!important}
    .mse-life .mse-life__media img{transition:none!important}
    .mse-life .mse-life__media figure:hover img{transform:none!important}
    .mse-life .mse-life__media a{cursor:pointer!important}
    .myromy-home-product-preview{display:grid;gap:6px;margin:6px 0 4px;padding:0;list-style:none;line-height:1.4;color:rgb(var(--text-color)/.78);text-align:left;font-size:14px}
    .myromy-home-product-preview li{position:relative;padding-left:15px}
    .myromy-home-product-preview li::before{content:'•';position:absolute;left:0;top:0;font-weight:700;color:rgb(var(--text-color))}
    @media(max-width:699px){
      .myromy-curated-family{gap:22px!important}
      .myromy-curated-family+.myromy-curated-family{margin-top:18px!important;padding-top:26px!important}
      .myromy-curated-row+.myromy-curated-row{margin-top:14px!important}
      .myromy-curated-row__grid[data-count="1"],.myromy-curated-row__grid[data-count="2"],.myromy-curated-row__grid[data-count="3"]{grid-template-columns:1fr!important;max-width:none!important}
      .myromy-curated-row__grid[data-count="4"]{grid-template-columns:repeat(2,minmax(0,1fr))!important;max-width:none!important}
      .myromy-home-product-preview{font-size:15px;gap:7px}
    }
    @media(min-width:390px) and (max-width:699px){
      .myromy-curated-row__grid[data-count="3"]{grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:10px!important}
      .myromy-curated-row__grid[data-count="3"] .product-card__info{gap:4px}
      .myromy-curated-row__grid[data-count="3"] .product-card__title{font-size:13px;line-height:1.3}
      .myromy-curated-row__grid[data-count="3"] price-list{font-size:13px}
    }
  `;

  function ensureStyles(){
    let style=document.getElementById('myromy-final-curation-styles');
    if(!style){style=document.createElement('style');style.id='myromy-final-curation-styles';document.head.appendChild(style)}
    style.textContent=STYLES;
  }
  function isGerman(){return (document.documentElement.lang||'').toLowerCase().startsWith('de')}
  function collectionHandle(){const m=window.location.pathname.match(/\/collections\/([^/?#]+)/);return m?m[1]:''}
  function editionRank(h){if(h.includes('signature'))return 0;if(h.includes('coffee'))return 1;if(h.includes('cream'))return 2;return 9}
  function classify(h){
    if(h.includes('multi-braeter'))return{family:'braeter',familyLabel:ui('familyBraeter'),row:h.includes('3-5l')?'35':'6',rowLabel:h.includes('3-5l')?'3,5 L':'6 L'};
    if(h.includes('brot-frische-topf'))return{family:'brottopf',familyLabel:ui('familyBrottopf'),row:h.includes('3-5l')?'35':'6',rowLabel:h.includes('3-5l')?'3,5 L':'6 L'};
    if(h.includes('brick'))return{family:'brick',familyLabel:ui('familyBrick'),row:h.includes('bbq')?'bbq':'classic',rowLabel:h.includes('bbq')?ui('rowBbq'):ui('rowClassic')};
    if(h.includes('plancha'))return{family:'plancha',familyLabel:ui('familyPlancha'),row:h.includes('bbq')?'bbq':'classic',rowLabel:h.includes('bbq')?ui('rowBbq'):ui('rowClassic')};
    return{family:'other',familyLabel:ui('familyOther'),row:'other',rowLabel:''};
  }

  const FAMILY_ORDER=['braeter','brottopf','brick','plancha','other'];
  const ROW_ORDER=['6','35','classic','bbq','other'];

  function mobileCardTitle(handle){
    const edition=handle.includes('coffee')?ui('editionCoffee'):handle.includes('cream')?ui('editionCream'):ui('editionSignature');
    let base='';
    if(handle.includes('multi-braeter'))base=ui('titleBraeter');
    else if(handle.includes('brot-frische-topf'))base=ui('titleBrottopf');
    else if(handle.includes('brick'))base=handle.includes('bbq')?ui('titleBrickBbq'):ui('titleBrickClassic');
    else if(handle.includes('plancha'))base=handle.includes('bbq')?ui('titlePlanchaBbq'):ui('titlePlanchaClassic');
    return base&&edition?`${base} · ${edition}`:'';
  }

  function applyMobileCardTitle(card){
    const link=card.querySelector('.product-card__title a');
    if(!link)return;
    if(!link.dataset.myromyFullTitle)link.dataset.myromyFullTitle=(link.textContent||'').replace(/\s+/g,' ').trim();
    const compact=mobileCardTitle(card.getAttribute('handle')||'');
    if(window.matchMedia('(max-width:699px)').matches&&compact){
      link.textContent=compact;
      link.setAttribute('aria-label',link.dataset.myromyFullTitle);
    }else{
      link.textContent=link.dataset.myromyFullTitle;
      link.removeAttribute('aria-label');
    }
  }

  function centerCard(card){
    card.style.textAlign='center';
    card.style.gridColumn='auto';
    card.style.gridRow='auto';
    const info=card.querySelector('.product-card__info');
    if(info){info.classList.add('product-card__info--center');info.style.textAlign='center';info.style.justifyItems='center';info.style.alignItems='center'}
    card.querySelectorAll('.product-card__title, price-list').forEach(el=>{el.style.width='100%';el.style.textAlign='center'});
    applyMobileCardTitle(card);
  }

  function curateCollection(){
    if(!isGerman()||!COLLECTIONS[collectionHandle()])return;
    const hasEditionFilter=Array.from(new URLSearchParams(window.location.search).keys()).some(key=>key.includes('color-pattern'));
    if(hasEditionFilter)return;
    const list=document.querySelector('product-list.product-list, product-list');
    if(!list||list.dataset.myromyCurated==='true')return;
    const cards=Array.from(list.children).filter(n=>n.matches?.('product-card[handle]'));
    if(!cards.length)return;

    const groups=new Map();
    cards.forEach(card=>{
      const handle=card.getAttribute('handle')||'';
      const meta=classify(handle);
      if(!groups.has(meta.family))groups.set(meta.family,{label:meta.familyLabel,rows:new Map()});
      const family=groups.get(meta.family);
      if(!family.rows.has(meta.row))family.rows.set(meta.row,{label:meta.rowLabel,cards:[]});
      family.rows.get(meta.row).cards.push({card,handle});
    });

    const fragment=document.createDocumentFragment();
    FAMILY_ORDER.forEach(familyKey=>{
      const family=groups.get(familyKey);if(!family)return;
      const familySection=document.createElement('section');
      familySection.className='myromy-curated-family';
      familySection.dataset.family=familyKey;
      familySection.style.cssText='grid-column:1/-1;display:flex;flex-direction:column;align-items:stretch;width:100%;min-width:0;gap:28px;position:relative;';
      const heading=document.createElement('h2');
      heading.className='myromy-curated-family__heading';
      heading.textContent=family.label;
      heading.style.cssText='width:100%;margin:0 auto;text-align:center;';
      familySection.appendChild(heading);

      ROW_ORDER.forEach(rowKey=>{
        const row=family.rows.get(rowKey);if(!row)return;
        row.cards.sort((a,b)=>editionRank(a.handle)-editionRank(b.handle));
        const rowWrap=document.createElement('div');
        rowWrap.className='myromy-curated-row';
        rowWrap.dataset.row=rowKey;
        rowWrap.style.cssText='display:flex;flex-direction:column;align-items:stretch;width:100%;min-width:0;gap:14px;position:relative;margin:0;';
        if(row.label){
          const label=document.createElement('p');
          label.className='myromy-curated-row__label';
          label.textContent=row.label;
          label.style.cssText='width:100%;margin:0 auto;text-align:center;position:static;';
          rowWrap.appendChild(label);
        }
        const grid=document.createElement('div');
        grid.className='myromy-curated-row__grid';
        grid.dataset.count=String(row.cards.length);
        grid.style.cssText='display:grid;width:100%;margin-inline:auto;align-items:start;justify-content:center;min-width:0;position:relative;grid-auto-flow:row;';
        row.cards.forEach(({card})=>{centerCard(card);grid.appendChild(card)});
        rowWrap.appendChild(grid);
        familySection.appendChild(rowWrap);
      });
      fragment.appendChild(familySection);
    });

    list.replaceChildren(fragment);
    list.dataset.myromyCurated='true';
    list.style.cssText='display:block;width:100%;min-width:0;';
  }

  function run(){
    ensureStyles();
    curateCollection();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();

  document.addEventListener('shopify:section:load',()=>{
    const list=document.querySelector('product-list.product-list, product-list');
    if(list)delete list.dataset.myromyCurated;
    run();
  });
})();
